<template>
    <div class="DriverWelcomePage">
        <SiteHeader/>

        <Card>
            <h1>Welcome to DumpTek</h1>
            <p>
                This website is intended for admin and manager use. To use DumpTek as a driver, please download our mobile app on the Apple App Store or Google Play Store.
            </p>

            <AppStoreBadges/>
        </Card>

        <SiteFooter/>
    </div>
</template>

<script>
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Card from '@/components/Card';
import AppStoreBadges from '@/components/AppStoreBadges';

export default {
    name: 'DriverWelcomePage',

    components: { SiteHeader, SiteFooter, Card, AppStoreBadges },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DriverWelcomePage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Card {
        max-width: 800px;
        margin: 0 auto;
        text-align: center;

        p {
            margin-top: $grid-gutter-width;
            font-size: 18px;
        }
    }

    .AppStoreBadges {
        margin-top: 30px;
    }

    .SiteFooter {
        align-self: flex-end;
    }
}
</style>
